import { Route } from '@angular/router';
import { authGuard, LoginComponent } from '@hypenation/auth';
import { RsvpPageComponent, sharedTicketRoutes } from '@hypenation/tickets';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { MyOrdersComponent } from './pages/my-orders/my-orders.component';
import { OrderDetailComponent } from './pages/order-detail/order-detail.component';
import { MyTicketsComponent } from './pages/my-tickets/my-tickets.component';
import { MyEventsComponent } from './pages/my-events/my-events.component';
import { CheckInHistoryComponent } from './pages/check-in-history/check-in-history.component';
import { WishlistComponent } from './pages/wishlist/wishlist.component';
import { EventsComponent } from './pages/events/events.component';
import { OrganisersComponent } from './pages/organisers/organisers.component';
import { OrganiserProfileComponent } from './pages/organiser-profile/organiser-profile.component';

const guardedSharedTicketRoutes = sharedTicketRoutes.filter(
  (route) => route.path !== 'rsvp/:token'
);

export const clientPortalRoutes: Route[] = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'rsvp/:token',
    component: RsvpPageComponent,
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        component: DashboardComponent,
      },
      {
        path: 'orders',
        component: MyOrdersComponent,
      },
      {
        path: 'orders/:orderNumber',
        component: OrderDetailComponent,
      },
      {
        path: 'tickets',
        component: MyTicketsComponent,
      },
      {
        path: 'my-events',
        component: MyEventsComponent,
      },
      {
        // The same screen as /tickets, filtered to one event and headed with that event's wallet
        // total. It cannot live under 'tickets/:eventUid' — the shared ticket routes already claim
        // 'tickets/:slug/:token' and 'tickets/:slug/:uuid/:eventTypeUid'.
        path: 'my-events/:eventUid',
        component: MyTicketsComponent,
      },
      // {
      //   path: 'check-ins',
      //   component: CheckInHistoryComponent,
      // },
      {
        path: 'wishlist',
        component: WishlistComponent,
      },
      {
        path: 'events',
        component: EventsComponent,
      },
      {
        path: 'organisers',
        component: OrganisersComponent,
      },
      {
        path: 'organisers/:uid',
        component: OrganiserProfileComponent,
      },
      // Shared ticket routes: view event, cart, checkout, order confirmation
      ...guardedSharedTicketRoutes,
    ],
  },
];
